var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-89.9 0 481.25 481.25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1A1F33;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2",
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pear"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.1,327.92,249.94,170.3a101,101,0,0,0-90.31-81.59,121.78,121.78,0,0,1,9.7-37.59c5.47-12.2,15.55-28.12,32.52-34.69A8.5,8.5,0,1,0,195.71.58C178,7.43,163.53,22.5,153.82,44.17c-.2.45-.39.91-.58,1.36-5.89-11-14.82-22.39-27.1-30.21-24.77-15.77-52-10.23-70.5-2.81A8.5,8.5,0,0,0,51,23.75c8.82,20.53,20.37,36.14,34.33,46.39a72.49,72.49,0,0,0,43.94,14.27,90.42,90.42,0,0,0,13.82-1.1c-.21,1.8-.38,3.58-.52,5.35a101,101,0,0,0-91,81.64L7.37,327.92A113.18,113.18,0,0,0,150.73,474.84,113.18,113.18,0,0,0,294.1,327.92ZM70.47,25.3C88.39,19.94,104,21.39,117,29.66,132.2,39.33,140.35,56.1,143.5,66,111.72,72,87.21,58.3,70.47,25.3Zm117.87,439a95.62,95.62,0,0,1-34.55-6.4,8.5,8.5,0,0,0-6.12,0A96.17,96.17,0,0,1,23.38,333.64c.09-.25.18-.5.25-.76L68,174.53a6.41,6.41,0,0,0,.17-.73,84,84,0,0,1,165.14,0,6.41,6.41,0,0,0,.17.73l44.36,158.35c.07.26.16.51.25.76a96.17,96.17,0,0,1-89.74,130.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,438.31c-36.74,0-66.63-32-66.63-71.26a3.5,3.5,0,0,0-7,0c0,43.15,33,78.26,73.63,78.26a3.5,3.5,0,1,0,0-7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruit);
export default __webpack_public_path__ + "static/media/fruit.952e23495b33ff92cd340fe3defe3248.svg";
export { ForwardRef as ReactComponent };